module.exports = __webpack_public_path__ + "img/br1.a2846a70.jpg";